import { useEffect, useState } from 'react';
import { addToCart } from '../utils/cart';
import { useNavigate, useParams } from 'react-router-dom';
import { addToWishlist } from '../utils/wishlist';

function ProductDetail() {
  const [showEMI, setShowEMI] = useState(false);
  const [product, setProduct] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const res = await fetch(`http://kolibusiness.com/backend/get-product.php?id=${id}`);
        const data = await res.json();
        setProduct(data);
      } catch (err) {
        console.error("Failed to fetch product:", err);
      }
    };
    fetchProduct();
  }, [id]);

  if (!product) return <p style={{ padding: 40 }}>Loading...</p>;
  if (product.error) return <p style={{ padding: 40 }}>{product.error}</p>;

  const handleEMIClick = () => setShowEMI(true);
  const closeEMI = () => setShowEMI(false);

  return (
    <div style={styles.container}>
      <img src={`http://kolibusiness.com/backend/uploads/${product.image}`} alt={product.title} style={styles.image} />
      <div style={styles.details}>
        <h2>{product.title}</h2>
        <p style={styles.price}>₹{product.price}</p>
        <p>{product.description}</p>

        <div style={styles.buttonGroup}>
          <button
            onClick={() => {
              addToWishlist(product);
              alert("Added to wishlist!");
            }}
            style={styles.button}
          >
            ❤️ Add to Wishlist
          </button>

          <button onClick={handleEMIClick} style={styles.emiButton}>💳 EMI Options Available</button>

          <button
            onClick={() => {
              addToCart(product);
              alert("Added to cart!");
            }}
            style={styles.button}
          >
            Add to Cart
          </button>

          <button
            onClick={() => {
              
              navigate("/cart");
              addToCart(product);
            }}
            style={styles.button}
          >
            Buy Now
          </button>
        </div>
      </div>

      {showEMI && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalContent}>
            <h3>EMI Options</h3>
            <ul>
              <li>1st Payment Part-20%</li>
              <li>2nd Payment Part-8 weeks EMI </li>
              <li>10% of Total Amnt per week</li>
              
            </ul>
            <button
 onClick={() => navigate("/emi-form")}
 

  style={styles.closeBtn}
>
  Proceed
</button>

          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  container: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: "30px",
    padding: "20px",
    background: "#f9f9f9",
    justifyContent: "center",
  },
  image: {
    width: "100%",
    maxWidth: "400px",
    height: "auto",
    borderRadius: "10px",
    objectFit: "cover"
  },
  details: {
    flex: "1 1 300px",
    maxWidth: "500px"
  },
  price: {
    fontSize: "24px",
    color: "#e53935",
    margin: "10px 0"
  },
  buttonGroup: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    gap: "12px",
    marginTop: "20px"
  },
  button: {
    padding: "12px",
    background: "#222",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    width: "100%"
  },
  emiButton: {
    padding: "14px",
    background: "#ffc107",
    color: "#000",
    fontWeight: "bold",
    border: "2px dashed #222",
    borderRadius: "6px",
    cursor: "pointer",
    width: "100%"
  },
  modalOverlay: {
    position: "fixed",
    top: 0, left: 0,
    width: "100%", height: "100%",
    background: "rgba(0, 0, 0, 0.5)",
    display: "flex", justifyContent: "center", alignItems: "center",
    zIndex: 1000
  },
  modalContent: {
    background: "#fff",
    padding: "30px",
    borderRadius: "8px",
    textAlign: "center",
    boxShadow: "0 0 10px rgba(0,0,0,0.3)",
    width: "90%",
    maxWidth: "400px"
  },
  closeBtn: {
    marginTop: "15px",
    padding: "8px 16px",
    border: "none",
    background: "#e53935",
    color: "#fff",
    cursor: "pointer",
    borderRadius: "5px"
  }
};


export default ProductDetail;
